import { FirebaseRemoteConfig } from "@capacitor-firebase/remote-config";
import { remoteDefaults } from "./remoteConfig";
import type { RemoteConfigShape } from "../types/domain";

const CONFIG_KEY = "tripai_config";

function isShape(value: unknown): value is RemoteConfigShape {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Partial<RemoteConfigShape>;
  return Boolean(candidate.features && candidate.plans && candidate.versions);
}

export async function loadRemoteConfig(): Promise<RemoteConfigShape> {
  const fallback = remoteDefaults;
  try {
    await FirebaseRemoteConfig.setDefaults({ defaults: { [CONFIG_KEY]: JSON.stringify(fallback) } });
    await FirebaseRemoteConfig.setSettings({
      fetchTimeoutInSeconds: 8,
      minimumFetchIntervalInSeconds: import.meta.env.DEV ? 0 : 3600
    });
    await FirebaseRemoteConfig.fetchAndActivate();
    const { value } = await FirebaseRemoteConfig.getString({ key: CONFIG_KEY });
    const parsed = JSON.parse(value) as unknown;
    return isShape(parsed) ? { ...parsed, plans: remoteDefaults.plans } : fallback;
  } catch {
    return fallback;
  }
}
